import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Box, Fade, Grid, Typography } from '@mui/material';
import { FileManagerInventoryFile } from '../../../redux/slices/slice_types';
import AssetIcon from '../../Job/JobTabs/JobTabAssetStatus/AssetIcon';

interface SelectedFileDisplayProps {
  selectedFile: FileManagerInventoryFile | null;
}

const SelectedFileDisplay = ({ selectedFile }: SelectedFileDisplayProps) => {
  if (!selectedFile) return null;
  const fileType = selectedFile.key && selectedFile.key.split('.').pop();

  return (
    <div>
      <Fade in timeout={600}>
        <LinkIconBox justifyContent="center" sx={{ color: 'primary.main', my: 1 }}>
          <PolarisIcon icon="link" height={30} />
        </LinkIconBox>
      </Fade>
      <Fade in timeout={1000}>
        <SelectedFileBox>
          <Grid container alignItems="center" flexWrap="nowrap" sx={{ wordBreak: 'break-all' }}>
            <AssetIcon type={fileType || ''} withColor />
            <Grid item sx={{ ml: 1 }}>
              <SelectedFileTypography variant="h3">{selectedFile.key}</SelectedFileTypography>
              <Typography variant="caption">{selectedFile.origin_slug}</Typography>
            </Grid>
          </Grid>
        </SelectedFileBox>
      </Fade>
    </div>
  );
};

export default SelectedFileDisplay;

const SelectedFileBox = styled(Box)`
  ${({ theme }) => `  
  background-color: ${theme.palette.primary.main}31;
  border: 2px solid ${theme.palette.primary.main};
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(2.5, 2)};

  .MuiDivider-root {
    margin: ${theme.spacing(2)} 0;
  }
  `}
`;

const SelectedFileTypography = styled(Typography)`
  font-size: 1.2rem;
`;

const LinkIconBox = styled(Box)`
  text-align: center;
  position: relative;
  margin: 0px;
  &:before,
  &:after {
    content: '';
    width: 2px;
    height: 15px;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
  }
  &:before {
    background-color: ${({ theme }) => theme.palette.default.main};
  }
  &:after {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;
